export const ArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8245 6.17499C11.6133 5.96381 11.2709 5.96381 11.0598 6.17499L8.00071 9.23404L4.94167 6.175C4.73049 5.96381 4.38809 5.96381 4.17691 6.175C3.96573 6.38618 3.96573 6.72857 4.17691 6.93975L7.61833 10.3812C7.72392 10.4868 7.86232 10.5396 8.00072 10.5396C8.06973 10.5396 8.13875 10.5264 8.20369 10.5002C8.26898 10.4738 8.33017 10.4341 8.3831 10.3812L11.8245 6.93975C12.0357 6.72857 12.0357 6.38617 11.8245 6.17499Z"
      fill="#0079B0"
    />
  </svg>
);
